import React from 'react';
import './TajweedCourse.css'; // Create a CSS file for styling

const TajweedCourse = () => {
    return (
        <div className="course-detail-container">
            <div className="course-content">
                <h2>Tajweed Course</h2>
                <p>The Tajweed Course is designed to help students perfect their recitation of the Quran by learning and applying the rules of Tajweed. Tajweed is the science that governs the correct pronunciation of Quranic words, ensuring that the reciter adheres to the phonetic rules of Arabic, thus preserving the meaning and beauty of the Quran as intended by Allah.</p>

                <h3>Course Objectives:</h3>
                <p>This course focuses on the following key areas:</p>
                <ul>
                    <li><strong>Mastering Pronunciation:</strong> Understand the articulation points (Makharij) of each Arabic letter to correctly pronounce every word in the Quran.</li>
                    <li><strong>Application of Rules:</strong> Learn the essential rules of Tajweed, such as Idgham, Ikhfa, and Qalqalah, ensuring accurate recitation.</li>
                    <li><strong>Rhythm and Melody:</strong> Develop a smooth and rhythmic flow in your recitation, preserving the beauty and cadence of Quranic verses.</li>
                    <li><strong>Connecting with Quranic Text:</strong> Gain a deeper connection with the Quran through proper recitation, enabling a more profound spiritual experience.</li>
                </ul>

                <h3>Course Structure:</h3>
                <p>The Tajweed Course is divided into three levels to accommodate learners of different abilities:</p>
                <ul>
                    <li><strong>Beginner Level:</strong> Focus on the basics of Arabic phonetics, the alphabet, and the foundational rules of Tajweed. Perfect for students who are new to Quranic recitation.</li>
                    <li><strong>Intermediate Level:</strong> Enhance your recitation skills by learning the detailed rules of Tajweed, such as prolongation (Madd) and stopping signs (Waqf), and apply them in Quranic reading.</li>
                    <li><strong>Advanced Level:</strong> Master complex Tajweed rules and engage in intensive practice to achieve fluency and perfection in recitation, suitable for students who want to recite like professional Qaris.</li>
                </ul>

                <h3>Key Features of the Course:</h3>
                <ul>
                    <li>One-on-one sessions with a qualified instructor for personalized feedback and guidance.</li>
                    <li>Weekly group recitation sessions to practice Tajweed with peers and instructors.</li>
                    <li>Comprehensive study materials, including audio recordings, Tajweed books, and practice exercises.</li>
                    <li>Monthly progress assessments to evaluate your recitation and ensure continuous improvement.</li>
                </ul>

                <h3>Who Should Join?</h3>
                <p>This course is ideal for:</p>
                <ul>
                    <li>Anyone seeking to improve their Quran recitation.</li>
                    <li>Individuals looking to develop a deeper spiritual connection through proper Quranic recitation.</li>
                    <li>Students preparing to become teachers of Quran or Hifz students aiming to recite the Quran with perfect Tajweed.</li>
                    <li>Muslims who want to gain more rewards for their Quran recitation by adhering to the rules of Tajweed.</li>
                </ul>

                <h3>Benefits of Learning Tajweed:</h3>
                <ul>
                    <li>Increases the beauty and clarity of your recitation, ensuring the proper transmission of Quranic meanings.</li>
                    <li>Enhances your concentration and mindfulness during recitation, leading to a more spiritual experience.</li>
                    <li>Allows you to follow the Sunnah of reciting the Quran with precision, just as the Prophet Muhammad (PBUH) did.</li>
                    <li>Provides you with the tools to teach others the proper way of reciting the Quran.</li>
                </ul>
            </div>

            <div className="course-image">
                <img src="./images/img1.jpg" alt="Tajweed Course" />
            </div>
        </div>
    );
};

export default TajweedCourse;
